<template>
  <v-main class="overflow-y-auto">
    <div style="min-height: 100%" class="flex items-center py-6 px-4">
      <v-progress-circular
        v-if="loading"
        indeterminate
        class="mx-auto"
        color="primary"
      ></v-progress-circular>

      <div v-else style="width: 500px" class="mx-auto">
        <div v-if="title" class="text-center">
          <AircapLogo class="mx-auto mb-8" size="50px" />
          <div class="mb-10 text-2xl font-bold">
            {{ title }}
          </div>
        </div>

        <slot />

        <LanguageSelector />
        <ThemeSelector />

        <div class="mt-4 text-xs text-medium-emphasis text-center">
          <a href="mailto:support@aircap.tech" class="text-medium-emphasis">support@aircap.tech</a>
        </div>
      </div>
    </div>
  </v-main>
</template>

<script setup lang="ts">
import AircapLogo from "@/components/AircapLogo.vue";
import LanguageSelector from "@/components/LanguageSelector.vue";
import ThemeSelector from "@/components/ThemeSelector.vue";

defineProps<{
  title?: string | false;
  loading?: boolean;
}>();
</script>
